import { Col } from "react-bootstrap";
import SpinerLoader from "../../../components/SpinerLoader";
import TopicsTable from "../components/TopicsTable";
import TopicsBarChart from "../components/TopicsBarChart";
import NoData from "../../../components/NoData";
import { useOutletContext } from "react-router-dom";
import type { DashboardOutletContext } from "../../../components/Layouts/GlobalDashboardLayout";
import { useTopicsForSurvey } from "../hook/useTopicsForSurvey";

export default function Topics() {
    const { data: topics, isLoading } = useTopicsForSurvey();

    const { section1Ref, section2Ref } = useOutletContext<DashboardOutletContext>();

  return (
      <div className="d-flex justify-content-center">
      {isLoading ?
        <SpinerLoader />
        :
        topics ?
          <>
            <Col className="mb-3 ps-0 dashboard-section" ref={section1Ref} >
              <TopicsTable topics={topics} />
            </Col>
            <Col className="mb-3" ref={section2Ref}>
              <TopicsBarChart topics={topics.slice(0, 10)} />
            </Col>
          </>
          : <NoData />
      }
    </div>
  );
}